export function arrayToString(keys: Array<string | undefined> = [], divider = ''): string {
    return keys.filter(Boolean).join(divider);
}
